import {useContext} from 'react';
import {Context as PlaidContext} from '../contexts/PlaidContext';

export const usePlaid = () => useContext(PlaidContext);
